import branchService from 'ApiService/SuperAdmin/branchService';
import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import CreateAdmin from './CreateAdmin';
import { useFormKeyboardSubmit } from 'pages/Hooks/useStepperKeyboardNavigation';
import ConfirmationModal from 'pages/Common/ConfirmationModal';

const Index = () => {
  const [adminData, setAdminData] = useState({
    adminName: '',
    adminEmail: '',
    adminPassword: '',
    branchId: '',
    contactNumber: '',
  });
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingBranch, setLoadingBranch] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [disable, setDisable] = useState(true);
  const router = useNavigate();
  const { state } = useContext(AuthContext);

  const fetchBranches = async () => {
    setLoadingBranch(true);
    try {
      const response = await branchService.allBranches(state?.user?.id);

      if (response.data.success) {
        setBranches(response.data.allBranches);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch branches.'
      );
    } finally {
      setLoadingBranch(false);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  const handleSubmit = async () => {
    if (
      adminData.adminName &&
      adminData.adminEmail &&
      adminData.adminPassword &&
      adminData.branchId &&
      adminData.contactNumber
    ) {
    } else {
      toast.error('All fields are required.');
    }
    setIsModalOpen(true);
  };
  const confirmCreation = async () => {
    setIsModalOpen(false);
    setLoading(true);
    try {
      const trimmedData = {
        adminName: adminData.adminName?.trim().replace(/\s+/g, ' '),
        adminEmail: adminData.adminEmail?.trim().replace(/\s+/g, ' '),
        adminPassword: adminData.adminPassword?.trim().replace(/\s+/g, ' '),
        branchId: adminData.branchId?.trim().replace(/\s+/g, ' '),
        contactNumber: adminData.contactNumber?.trim().replace(/\s+/g, ' '),
      };

      const response = await branchService.createAdmin(trimmedData);

      if (response.data.success) {
        setAdminData({
          adminName: '',
          adminEmail: '',
          adminPassword: '',
          branchId: '',
          contactNumber: '',
        });
        toast.success(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useFormKeyboardSubmit(handleSubmit, disable, loading);

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3  3xl:w-7/12">
        <Card
          extra={
            ' -mt-[280px] w-full md:-mt-[340px] md:px-[70px] h-full mx-auto pb-3'
          }
        >
          <div className="rounded-[20px]">
            <UseContextProvider>
              <CreateAdmin
                setAdminData={setAdminData}
                adminData={adminData}
                branches={branches}
                disable={disable}
                setDisable={setDisable}
                loadingBranch={loadingBranch}
              />
            </UseContextProvider>
          </div>
          <div className="mt-4 flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
            <button
              disabled={disable}
              onClick={handleSubmit}
              className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
            >
              {loading ? 'Loading..' : 'Submit'}
            </button>
          </div>
        </Card>
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={confirmCreation}
        title="Create Admin Confirmation"
        message={`Are you sure to create ${adminData.adminName} as a admin user ?`}
        confirmText="Yes, Create"
        cancelText="Cancel"
        icon="info"
      />
    </div>
  );
};

export default Index;
